module.exports = __webpack_public_path__ + "img/pain.4ba180cb.png";